import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-black text-body2" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row text-body1 text-weight-bold text-black" }, " Ta bort användare ")
  ])
], -1)
const _hoisted_2 = { class: "row q-col-gutter-md q-mt-md" }
const _hoisted_3 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { style: {"max-width":"1000px","min-width":"400px"} }, {
    default: _withCtx(() => [
      _createVNode(_component_q_form, {
        onSubmit: _withModifiers(_ctx.onConfirm, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, "Vill du ta bort användare: " + _toDisplayString(_ctx.user?.email), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_separator),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                flat: "",
                label: "Stäng",
                onClick: _ctx.close,
                disable: _ctx.deleteing
              }, null, 8, ["onClick", "disable"]),
              _createVNode(_component_q_btn, {
                flat: "",
                label: "Ta bort",
                color: "negative",
                type: "submit",
                loading: _ctx.deleteing
              }, null, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }))
}